import React from 'react';
import styled from 'styled-components';
import SVG from 'react-inlinesvg';
// import Logo from 'src/static/logo2.svg';
import Background from 'src/static/sign-in-background.png';
import { Form as MyForm } from '@ant-design/compatible';
import { withIsMobile } from 'src/utils/responsive';
import {
  SITE_SIDEBAR_TABS,
  resolveSiteSidebarTabs
} from 'src/constants/sidebarTabs';
import '@ant-design/compatible/assets/index.css';
import { LockOutlined, UserOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';
import Logo from "src/static/logo-open.svg";
import GridImg from "src/static/vector-square-back.png";
import logoPowered from "src/static/logo-powered.svg";
import {
  Checkbox,
  Select,
  Row,
  Form,
  Col,
  Spin,
  Input,
  Button,
  Modal,
  Card
} from 'antd';
import { ButtonRadius } from 'src/components/elements/Button';
import Notify from 'src/components/meta/Notification';
import lock from 'src/static/icons/input-icons/lock.svg';
import user from 'src/static/icons/input-icons/user.svg';
import eye from 'src/static/icons/password-show.svg';

// Terms & conditions shown on sign-in. Must be accepted before logging in.
// Keep in sync with the Sprout POS, desktop and mobile apps.
const TERMS_TITLE = 'Terms & Conditions';
const TERMS_PARAGRAPHS = [
  'All data, information, reports, pricing, recipes and content accessed through this system are the confidential and proprietary property of Sprout.',
  'I hereby agree not to use, resell, duplicate, copy, reproduce, distribute or disclose any information or data obtained from this system to any third party, and to use it solely for authorised Sprout business purposes.',
  'Any unauthorised use, copying, reproduction, sale or disclosure of this data is strictly prohibited and may result in disciplinary and/or legal action.'
];

const FormItem = MyForm.Item;
const Inputs = styled(Input)`
  .ant-input-affix-wrapper > input.ant-input {
    padding: 0;
    border-radius: 0.8em;
    border: none;
    outline: none;
  }
  .ant-input-affix-wrapper .ant-input {
    min-height: 100%;
    padding-left: 30px !important;
    border-radius: 0.8em;
  }
  box-shadow: 0px 8px 15px 0px rgba(0, 0, 0, 0.13);
  height: 3.7em;
  padding-left: 2em;
  border-radius: 0.8em;
  border: none;
  //.ant-input:focus {
  //  border-bottom: 2px solid rgba(0, 136, 142, 0.2);
  //}
`;
function onChange(e) {
  console.log(`checked = ${e.target.checked}`);
}
class PassFormClass extends React.Component {
  compareToFirstPassword = (rule, value, callback) => {
    const { form } = this.props;
    if (value && value !== form.getFieldValue('password')) {
      callback('The passwords do not match!');
    } else {
      callback();
    }
  };

  validateToNextPassword = (rule, value, callback) => {
    const { form } = this.props;
    if (value) {
      form.validateFields(['confirm'], { force: true });
    }
    callback();
  };
  render() {
    return (
      <MyForm layout="vertical">
        <FormItem label={<span>Password</span>}>
          {this.props.form.getFieldDecorator('password', {
            rules: [
              { min: 5, message: 'Password must be minimum 5 characters.' },
              { required: true, message: 'Password required' },
              {
                validator: this.validateToNextPassword
              }
            ]
          })(<Input.Password />)}
        </FormItem>
        <FormItem label={<span>Confirm Password</span>}>
          {this.props.form.getFieldDecorator('confirmpassword', {
            rules: [
              { required: true, message: 'Confirm Password' },
              {
                validator: this.compareToFirstPassword
              }
            ]
          })(<Input.Password min={4} />)}
        </FormItem>
      </MyForm>
    );
  }
}
const PassForm = MyForm.create()(PassFormClass);
class SignIn extends React.Component {
  static defaultProps = {
    error: null,
    firstLogin: false
  };
  componentWillMount = () => {
    if (window.cordova) {
      document.addEventListener('backbutton', this.handleBack);
    }
  };
  exit = false;
  handleBack = () => {
    Notify('info', 'Press back again to close the app', '', 2);
    if (this.exit) {
      navigator.app.exitApp();
    }
    this.exit = true;
    setTimeout(() => {
      this.exit = false;
    }, 2000);
  };
  componentWillUnmount = () => {
    if (window.cordova) {
      document.removeEventListener('backbutton', this.handleBack);
    }
  };
  handleSubmit = event => {
    event.preventDefault();

    if (!this.state.agreedTerms) {
      Notify(
        'error',
        'Terms & Conditions',
        'Please accept the Terms & Conditions to sign in.'
      );
      return;
    }

    this.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        values.type = 'Technician';
        this.signIn(values);
      }
    });
  };

  // Buyers and managers only see the tabs their company was granted, so land
  // them on the first one they actually have rather than a fixed page they may
  // not be able to navigate back to.
  landingPathForSiteRole = async () => {
    let sites = this.props.sites;

    // Nothing has fetched sites yet on a first login, and without them the
    // resolver falls back to the full tab set. Read the sites off the resolved
    // action rather than this.props, which may not have re-rendered yet.
    if (!sites || !sites.length) {
      try {
        const action = await this.props.findAllSites();
        sites = (action && action.data && action.data.allSites) || [];
      } catch (e) {
        // Non-fatal — fall through to the default tab set below.
      }
    }

    const allowed = resolveSiteSidebarTabs(this.props.user, sites);
    const firstTab = SITE_SIDEBAR_TABS.find(tab => allowed.includes(tab.key));

    return firstTab ? firstTab.path : '/admin/specialmanagement';
  };

  signIn = values => {
    this.props
      .signIn(values)
      .then(async () => {
        this.setState({ loading: false });
        if (this.props.user.firstLogin) {
          this.setState({ firstLogin: true });
        } else if (this.props.user.type === 'admin') {
          this.props.push('/admin/dashboard');
        } else if (
          this.props.user.type === 'manager' ||
          this.props.user.type === 'buyer'
        ) {
          this.props.push(await this.landingPathForSiteRole());
        } else if (
          this.props.user.type === 'user' &&
          this.props.user.email !== 'Email'
        ) {
          // Staff start on today's checklists; Action Plan is next in their menu.
          this.props.push('/admin/checklists');
        }
      })
      .catch(e => {
        this.setState({ loading: false });
        Notify('error', 'Error', e);
      });
  };

  toggleShowPass = () => {
    const { state } = this;
    this.state.passShow === 'password'
      ? this.setState({ passShow: 'text' })
      : this.setState({ passShow: 'password' });
  };

  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      passShow: 'password',
      newPassVisible: false,
      agreedTerms: false,
      termsVisible: false
    };
    this.onFinish = this.onFinish.bind(this);
  }

  passForm;
  handleChangePassword = e => {
    e.preventDefault();
    this.passForm.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        this.setState({ loading: true });
        this.props
          .changePassword(values)
          .then(() => {
            Notify('success', 'Successfully set password');
            this.setState({ loading: false, firstLogin: false });
          })
          .catch(e => {
            this.setState({ loading: false });
            Notify('error', e);
          });
      }
    });
  };
  handleOk = e => {
    window.location.reload();
    console.log(e);
    this.setState({
      newPassVisible: false
    });
  };

  handleCancel = e => {
    window.location.reload();
    console.log(e);
    this.setState({
      newPassVisible: false
    });
  };
  handleSubmitPassReset = values => {
    window.location.reload();
    this.onFinish(values);
  };
  onFinish = values => {
    const MSG = {
      to: ['chair@gnfigureskating.co.za'],
      from: 'info@sprout-management.co.za',
      subject: 'Password Reset Request',
      text: ' ',
      html: `
    
      <style type="text/css">  
      body, #bodyTable{background-color:white}
      #emailHeader{background-color:white}
      #emailBody{background-color:#FFFFFF; border:1px solid #CCCCCC;}
      #emailFooter{background-color:#E1E1E1;}      
</style>
<body bgcolor="#E1E1E1" leftmargin="0" marginwidth="0" topmargin="0" marginheight="0" offset="0">
<center style="background-color:#E1E1E1;">
<table border="0" cellpadding="0" cellspacing="0" height="100%" width="100%" id="bodyTable" style="table-layout: fixed;max-width:100% !important;width: 100% !important;min-width: 100% !important;">
  <tr>
    <td align="center" valign="top" id="bodyCell">      
      <table bgcolor="#E1E1E1" border="0" cellpadding="0" cellspacing="0" width="500" id="emailHeader">
        <!-- HEADER ROW // -->
        <tr>
          <td align="center" valign="top">
            <!-- CENTERING TABLE // -->
            <table border="0" cellpadding="0" cellspacing="0" width="100%">
              <tr>
                <td align="center" valign="top">
                  <!-- FLEXIBLE CONTAINER // -->
                  <table border="0" cellpadding="10" cellspacing="0" width="500" class="flexibleContainer">
                    <tr>
                      <td valign="top" width="500" class="flexibleContainerCell">

                        <!-- CONTENT TABLE // -->
                        <table align="left" border="0" cellpadding="0" cellspacing="0" width="100%">
                          <tr>
                       
                            <td align="right" valign="middle" class="flexibleContainerBox">
                              <table border="0" cellpadding="0" cellspacing="0" width="100%" style="max-width:100%;">
                                <tr>
                                  <td align="left" class="textContent">
                                    <!-- CONTENT // -->
                                   
                                  </td>
                                </tr>
                              </table>
                            </td>
                          </tr>
                        </table>
                      </td>
                    </tr>
                  </table>
                  <!-- // FLEXIBLE CONTAINER -->
                </td>
              </tr>
            </table>
            <!-- // CENTERING TABLE -->
          </td>
        </tr>
        <!-- // END -->
      </table>     
      <!-- EMAIL BODY // -->   
      <table bgcolor="#FFFFFF" border="0" cellpadding="0" cellspacing="0" width="500" id="emailBody">
        <!-- MODULE ROW // -->
        <tr>
          <td align="center" valign="top">
            <!-- CENTERING TABLE // -->
            <table border="0" cellpadding="0" cellspacing="0"   style="color:#FFFFFF;" bgcolor="#FFFFFF">
              <tr>
                <td align="center" valign="top">
                  <!-- FLEXIBLE CONTAINER // -->
                 
                  <table border="0" cellpadding="0" cellspacing="0" width="500"   class="flexibleContainer">
                    <tr>
                      <td align="center" valign="top" width="500" class="flexibleContainerCell">

                        <!-- CONTENT TABLE // -->
                      
                        <table border="0" cellpadding="0" cellspacing="0" width="100%" z-index="100" >
                               <td align="center" valign="top" width="500" class="flexibleContainerCell  ">   
                                <img alt="" src="https://i.ibb.co/WgbVP0b/logo.png" width="350" height="85" style="display: block; border-radius: 8px 8px 8px 8px; font-family: Lato, Helvetica, Arial, sans-serif; color: #9AA31E; font-size: 18px;margin-top: 18px;" border="0">     <tr>
                            <td align="center" valign="top" class="textContent">
                              <h1 style="color:black;line-height:100%;font-family:Helvetica,Arial,sans-serif;font-size:30px;font-weight:normal;margin-bottom:20px;text-align:center;">Password Reset Enquiry</h1>
                              <h2 style="text-align:center;font-weight:normal;font-family:Helvetica,Arial,sans-serif;font-size:17px;margin-bottom:10px;color: black;line-height:135%;">You have received a Password Reset Enquiry from <br /> sprout-management Member Portal</h2>
                            </td>
                          </tr>
                        </table>
                        <!-- // CONTENT TABLE -->
                      </td>
                    </tr>
                  </table>
                  <!-- // FLEXIBLE CONTAINER -->
                </td>
              </tr>
            </table>
            <!-- // CENTERING TABLE -->
          </td>
        </tr>
        <!-- MODULE ROW // -->
        <tr mc:hideable>
          <td align="center" valign="top">
            <!-- CENTERING TABLE // -->
            <table border="0" cellpadding="0" cellspacing="0" width="100%" height="300" >
              <tr>
                <td align="center" valign="top">
                  <!-- FLEXIBLE CONTAINER // -->
                  <table border="0" cellpadding="0" cellspacing="0" width="300" class="flexibleContainer">
                    <tr>
                      <td valign="top" width="500" class="flexibleContainerCell">
                        <!-- CONTENT TABLE // -->
                        <table p align="left" border="0" cellpadding="0" cellspacing="0" width="120%">
                          <tr>
                            <td align="center" valign="top" class="flexibleContainerBox">
                               <table border="0" cellspacing="0" cellpadding="0" >
            
                        <tr style="font-family: sans-serif; font-size: 17px; letter-spacing: 1px; color:black">
                          <td class="role"><br />
                          <strong> Name </strong> &nbsp;&nbsp;:&nbsp;&nbsp; ${values.firstName
        }<br />
                          <strong> Email </strong> &nbsp;&nbsp;:&nbsp;&nbsp; ${values.loginEmail
        }<br />
                 
                      
                       
                             <br /><br />
                          </td>
                        </tr>
                        <table>
                            </td>
                          </tr>
                        </table>
                        <!-- // CONTENT TABLE -->

                      </td>
                    </tr>
                  </table>
                  <!-- // FLEXIBLE CONTAINER -->
                </td>
              </tr>
            </table>
            <!-- // CENTERING TABLE -->
          </td>
        </tr>
        <!-- // MODULE ROW -->


        <!-- MODULE ROW // -->
       
<table border="0" cellpadding="0" cellspacing="0" width="100%"  style="color:#FFFFFF;" bgcolor="#FFFFFF" style="text-align:center;font-weight:normal;font-family:Helvetica,Arial,sans-serif;font-size:13px;margin-bottom:-80px;color: lightgray;line-height:135%;">
              <tr>
                <td align="center" valign="top">
                
                  <table border="0" cellpadding="0" cellspacing="0" width="500"   class="flexibleContainer">
                    <tr>
                      <td align="center" valign="top" width="500" class="flexibleContainerCell">

                    
                        <table border="0" cellpadding="30" cellspacing="0" width="100%">
                      
                    
                          <tr>
                            <td align="center" valign="top" class="textContent">
        
                              <h2 style="text-align:center;font-weight:normal;font-family:Helvetica,Arial,sans-serif;font-size:13px;margin-bottom:0px;color: grey;line-height:135%;">2022@sprout-management</h2>
               
                            </td>
                          </tr>
                        </table>
                        <!-- // CONTENT TABLE -->

                      </td>
                    </tr>
                  </table>
                  <!-- // FLEXIBLE CONTAINER -->
                </td>
              </tr>
            </table>
     `
    };
    fetch('https://www.vcsappcloud.com/emailclient/sendmail', {
      method: 'POST',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json; charset=utf-8'
      },
      body: JSON.stringify(MSG)
    }).then(async res => {
      if (!res.ok) {
        console.log('handle error');
      }
      console.log('handle success');

      this.setState({
        newPassVisible: false,
        submitDisabled: true,
        firstName: '',
        loginEmail: ''
      });
    });
  };
  render() {
    const { loading, isMobile } = this.props;
    const { getFieldDecorator } = this.props.form;

    return (
      // <Section className="panel" {...this.props} >
      <div
        style={{
          background: '#1C1C1C',
          minHeight: '100vh',
          // The decorative grid is wider than a phone viewport; clip it rather
          // than letting it create a horizontal scrollbar.
          overflowX: 'hidden'
        }}
      >
        {/*<img
          src={Background}
          style={{ position: "absolute", right: 0, top: 0 }}
        />*/}
        <Row type="flex" justify="space-around" align="middle" >
          <img
            src={GridImg}
            alt=""
            style={{
              width: isMobile ? '100%' : '100em',
              maxWidth: isMobile ? '100%' : '100em',
              position: 'absolute',
              margin: 'auto'
            }}
          />
          <Row
            style={{
              margin: 'auto',
              textAlign: 'center',
              position: 'absolute',
              // Anchored left on desktop; centred on mobile, where an 18em logo
              // plus a 6em offset overflows a 375px viewport.
              left: isMobile ? 0 : '6em',
              right: isMobile ? 0 : 'auto',
              top: isMobile ? '1.5em' : '3em',
              justifyContent: isMobile ? 'center' : undefined
            }}
          >

            <img
              src={Logo}
              alt="Sprout Management"
              style={{
                marginBottom: 30,
                width: isMobile ? '11em' : '18em',
                marginLeft: isMobile ? 0 : '-1em'
              }}
            />

          </Row>
          <Col xs={22} md={24}>
            <Spin spinning={this.state.loading}>
              <MyForm onSubmit={this.handleSubmit}>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    // Leave room under the logo on mobile instead of centring
                    // the card behind it.
                    minHeight: isMobile ? "100vh" : "105vh",
                    paddingTop: isMobile ? "6em" : 0,
                    paddingBottom: isMobile ? "2em" : 0,
                    overflowY: "hidden"

                  }}
                >
                  <Card
                    style={{
                      width: "100%",
                      borderRadius: "1em",
                      background: "white",
                      textAlign: "center",
                      maxWidth: "30em",
                      border: "none",
                      padding: isMobile ? "0.25em" : "1em",
                    }}
                  >
                    <h1
                      style={{
                        lineHeight: isMobile ? '1.1' : '5px',
                        fontSize: isMobile ? '44px' : '60px',
                        color: '#80CE90',
                        textAlign: 'center',
                        fontFamily: "Caveat",
                        fontWeight: 300
                      }}
                    >
                      Welcome <br /></h1>
                    <p
                      style={{
                        fontFamily: 'Open Sans',
                        fontFamily: "Poppins",
                        marginBottom: '40px',
                        color: 'black',
                        fontSize: '16px',
                        fontWeight: '500'
                      }}
                    >
                      Sign into your account
                    </p>
                    <FormItem
                    //label={
                    //  <span style={{ color: "grey", fontSize: 15 }}>
                    //    Username
                    //  </span>
                    //}
                    >
                      {getFieldDecorator('email', {
                        rules: [
                          {
                            //required: true,
                            //message: "Username required"
                          }
                        ]
                      })(
                        <Inputs
                          placeholder="Email"
                          // prefix={
                          //   <UserOutlined
                          //     style={{
                          //       paddingRight: '0.5em',
                          //       color: 'lightgrey'
                          //     }}
                          //   />
                          // }
                          style={{
                            width: '100%',
                            border: 0,
                            borderRadius: 10
                          }}
                        />
                      )}
                    </FormItem>
                    <FormItem
                    //label={
                    //  <span style={{ color: "grey", fontSize: 15 }}>
                    //    Password
                    //  </span>
                    //}
                    >
                      {getFieldDecorator('password', {
                        rules: [{ required: true, message: 'Password required' }]
                      })(
                        <Inputs.Password
                          placeholder="Password"
                          // prefix={
                          //   <LockOutlined
                          //     style={{
                          //       paddingRight: '0.5em',
                          //       color: 'lightgrey'
                          //     }}
                          //   />
                          // }
                          type="password"
                          style={{
                            boxShadow: '0px 8px 15px 0px rgba(0, 0, 0, 0.13)',
                            height: '3.7em',
                            paddingLeft: "2em",
                            marginTop: "1em",
                            borderRadius: 10,
                            border: 'none'
                          }}
                        />
                      )}
                    </FormItem>
                    {/* <p
                    style={{
                      right: '40px',
                      position: 'absolute',
                      marginTop: '-1.5em',
                      color: 'grey',
                      fontSize: '13px'
                    }}
                    onClick={e => this.setState({ newPassVisible: true })}
                  >
                    Forgot Password?
                  </p> */}
                    {/* <p
                    style={{
                      fontSize: '13px',
                      marginBottom: '-0em',
                      paddingTop: '1em'
                    }}
                  >
                    New User? Enter{' '}
                    <span
                      style={{ color: '#80CE90', fontWeight: 600 }}
                    >
                      1234
                    </span>{' '}
                    to create a password
                  </p> */}
                    <FormItem style={{ marginBottom: 0, textAlign: 'left' }}>
                      <Checkbox
                        checked={this.state.agreedTerms}
                        onChange={e =>
                          this.setState({ agreedTerms: e.target.checked })
                        }
                        style={{ lineHeight: '1.4em' }}
                      >
                        I agree to the{' '}
                        <a
                          style={{ textDecoration: 'underline', color: '#3f9d54' }}
                          onClick={e => {
                            e.preventDefault();
                            e.stopPropagation();
                            this.setState({ termsVisible: true });
                          }}
                        >
                          Terms &amp; Conditions
                        </a>
                      </Checkbox>
                    </FormItem>
                    <FormItem>
                      <ButtonRadius
                        style={{
                          marginTop: '1em',
                          height: 55,
                          width: '100%',
                          fontSize: 14,
                          border: 'none',
                          fontFamily: 'Open Sans',
                          textShadow: 'none',
                          backgroundColor: '#80CE90',
                          borderRadius: "0.8em"
                        }}
                        type="primary"
                        htmlType="submit"
                        size="large"
                        block
                        disabled={!this.state.agreedTerms}
                      >
                        SIGN IN
                      </ButtonRadius>
                    </FormItem>
                    {/* Don't have an account? <Link to="/signup">Sign Up</Link> */}
                  </Card>


                  {/* <img src={logoPowered} style={{ marginBottom: 30, width: '10em', marginLeft: "-1em", }} /> */}


                </div>
              </MyForm>
            </Spin>
          </Col>

        </Row>
        <Modal
          title={TERMS_TITLE}
          visible={this.state.termsVisible}
          onOk={e => this.setState({ agreedTerms: true, termsVisible: false })}
          onCancel={e => this.setState({ termsVisible: false })}
          okText={'I Agree'}
          cancelText={'Close'}
        >
          {TERMS_PARAGRAPHS.map((p, i) => (
            <p key={i} style={{ color: '#4b4b4b', fontSize: 13 }}>
              {p}
            </p>
          ))}
        </Modal>

        <Modal
          title="Set Password"
          visible={this.state.firstLogin}
          onOk={this.handleChangePassword}
          onCancel={e => this.setState({ firstLogin: false })}
          okText="Save"
          cancelText="Cancel"
        >
          <PassForm wrappedComponentRef={form => (this.passForm = form)} />
        </Modal>
        <Modal
          title="Request Password Reset"
          visible={this.state.newPassVisible}
          footer={null}
          // onOk={this.handleSubmitPassReset}
          onCancel={e => this.setState({ newPassVisible: false })}
        // okText="Save"
        // cancelText="Cancel"
        >
          <Form onFinish={this.handleSubmitPassReset}>
            <div className="col-sm-12 col-md-12 col-lg-12">
              <Form.Item
                name="firstName"
                rules={[{ required: true, message: false }]}
                hasFeedback
              >
                <Input
                  // addonBefore={selectBefore}
                  placeholder="Name & Surname"
                />
              </Form.Item>
            </div>
            <div className="col-sm-12 col-md-12 col-lg-12">
              <Form.Item
                name="loginEmail"
                rules={[{ required: true, message: false, type: 'email' }]}
                hasFeedback
              >
                <Input placeholder="Login Email" type="email" />
              </Form.Item>
            </div>
            {/*<div className='col-sm-12 col-md-12 col-lg-12'>
                      <Form.Item
                        name='details'
                        rules={[{ required: true, message: false }]}
                        hasFeedback
                      >
                        <StyledTextArea
                          placeholder='Enquiry'
                          showCount
                          maxLength={100}
                          style={{ height: 120, border: "1px solid black" }}
                          //onChange={onChange}
                        />
                      </Form.Item>
                    </div>*/}
            <div className="col-lg-12 m-t-lg-12 text-center">
              <Form.Item>
                <Button
                  className="ht-btn ht-btn-default p-l-lg-30 p-r-lg-30"
                  style={{
                    textTransform: 'none',
                    backgroundColor: '#80CE90',
                    border: '4px solid #80CE90',
                    height: '2.5em',
                    fontWeight: 500,
                    float: 'right'
                  }}
                  type="primary"
                  htmlType="submit"
                >
                  SEND
                </Button>{' '}
              </Form.Item>{' '}
            </div>
          </Form>
        </Modal>
      </div>
    );
  }
}

const WrappedSignIn = MyForm.create()(withIsMobile(SignIn));

export default WrappedSignIn;
